module.exports = __webpack_public_path__ + "img/car-dealer.ebaa8c16.svg";